'use strict';

import React, { Component } from 'react'

import MenuItem from '@Pure/MenuItem'
import Link     from '@Pure/Link'
import Logo     from '@Pure/Logo'

const { app, qwest } = window;

export default class ECSubmenu extends Component
{
	state = { loading: false };

	requestSessionSwitch = () =>
	{
		const props = this.props, component = this;

		qwest.post('/switch-as-user')
		.then(function (xhr, response)
		{
			app.state.session = response.session;

			app.state.cart = [];

			app.state.session.order_process =
			{
				'billing': { },
				'shipping': { },
				'payment': { }
			};

			app.emit('sessionChange', { label: 'switch-as-user' });

			props.history.push('/accueil');
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const props = this.props, component = this;

		let output =
		(
			<div className={ 'c-sub-menu' +
				(props.open ? ' c-sub-menu--open' : '') }>

				<ul className="c-sub-menu__menu">

					{
						props['can-use-abondement'] ?
						(
							<li className="c-sub-menu__item is-abondement">
								<span className="c-sub-menu__link is-abondement"
									onClick={ props.onAbondementClick }>
									Abondement CE&nbsp;: { props.abondement }&nbsp;€
								</span>
							</li>
						)
						: undefined
					}

					<MenuItem base_class="c-sub-menu__item" path="/mes-commandes"
						history={ props.history }>
						<Link href="/mes-commandes" className="c-sub-menu__link">
							Commandes du CSE
						</Link>
					</MenuItem>

					<MenuItem base_class="c-sub-menu__item" path="/mes-factures"
						history={ props.history }>
						<Link href="/mes-factures" className="c-sub-menu__link">
							Factures du CSE
						</Link>
					</MenuItem>

					<MenuItem base_class="c-sub-menu__item" path="/panier"
						history={ props.history }>
						<Link href="/panier" className="c-sub-menu__link">
							Panier
						</Link>
					</MenuItem>

					<MenuItem base_class="c-sub-menu__item"
						history={ props.history }>
						<button className="c-sub-menu__link"
							onClick={ component.requestSessionSwitch }>
							Revenir en mode utilisateur
						</button>
					</MenuItem>

					<MenuItem base_class="c-sub-menu__item" path="/logout"
						history={ props.history }>
						<a href="/logout" className="c-sub-menu__link"
							onClick={ props.logout }>
							Déconnexion
						</a>
					</MenuItem>

				</ul>

			</div>
		);

		return output;
	}
}